import styled from "styled-components";

const CardBody = styled.div`
  padding: 1rem;
`;

export default CardBody;
